import { useState } from "react";
import { PopupState, PopupTypes } from "@/components/Vacancy/VacancyModel";

const usePopupState = () => {
  const [popupState, setPopupState] = useState<PopupState>({
    [PopupTypes.ShowJobApply]: false,
    [PopupTypes.ShowErrorPopup]: false,
    [PopupTypes.ShowSuccessPopup]: false,
  });

  const setPopup = (popupName: PopupTypes, value: boolean) => {
    setPopupState((prevState) => ({
      ...prevState,
      [popupName]: value,
    }));
  };

  return { popupState, setPopup };
};

export default usePopupState;
